module.exports = __webpack_public_path__ + "static/media/48.e142c0f6.jpg";